var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrbig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.244141 19.5797V0.22168H19.6022V19.5797H0.244141ZM5.08365 14.7402H14.7627V5.06119H5.08365V14.7402ZM0.244141 43.7772V24.4192H19.6022V43.7772H0.244141ZM5.08365 38.9377H14.7627V29.2587H5.08365V38.9377ZM24.4417 19.5797V0.22168H43.7997V19.5797H24.4417ZM29.2812 14.7402H38.9602V5.06119H29.2812V14.7402ZM38.9602 43.7772V38.9377H43.7997V43.7772H38.9602ZM24.4417 29.2587V24.4192H29.2812V29.2587H24.4417ZM29.2812 34.0982V29.2587H34.1207V34.0982H29.2812ZM24.4417 38.9377V34.0982H29.2812V38.9377H24.4417ZM29.2812 43.7772V38.9377H34.1207V43.7772H29.2812ZM34.1207 38.9377V34.0982H38.9602V38.9377H34.1207ZM34.1207 29.2587V24.4192H38.9602V29.2587H34.1207ZM38.9602 34.0982V29.2587H43.7997V34.0982H38.9602Z",
    fill: "#004EA8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrbig);
export default __webpack_public_path__ + "static/media/qrbig.d444ae3b358d2eff90d7e3f6c89f701b.svg";
export { ForwardRef as ReactComponent };